// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestProtocolId } from './HarvestProtocol';
import { harvestProtocolOperationTemplateId } from './HarvestProtocolOperationTemplate';
import { harvestOperationTemplateKpiId } from './HarvestOperationTemplateKpi';
import { operatorId } from './Operator';
import { z } from 'zod';
export const harvestProtocolKpiId = (z.number());
export const harvestProtocolKpi = z.object({
    id: harvestProtocolKpiId,
    protocol_id: harvestProtocolId,
    protocol_op_template_id: harvestProtocolOperationTemplateId.nullable(),
    source_template_kpi_id: harvestOperationTemplateKpiId.nullable(),
    code: z.string().nullable(),
    name: z.string(),
    formula: z.string(),
    result_unit: z.string().nullable(),
    result_display_unit: z.string().nullable(),
    display_group: z.string().nullable(),
    display_order: z.number(),
    enabled: z.boolean(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
});
export const harvestProtocolKpiInitializer = z.object({
    id: harvestProtocolKpiId.optional(),
    protocol_id: harvestProtocolId,
    protocol_op_template_id: harvestProtocolOperationTemplateId.optional().nullable(),
    source_template_kpi_id: harvestOperationTemplateKpiId.optional().nullable(),
    code: z.string().optional().nullable(),
    name: z.string(),
    formula: z.string(),
    result_unit: z.string().optional().nullable(),
    result_display_unit: z.string().optional().nullable(),
    display_group: z.string().optional().nullable(),
    display_order: z.number().optional(),
    enabled: z.boolean().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
export const harvestProtocolKpiMutator = z.object({
    id: harvestProtocolKpiId.optional(),
    protocol_id: harvestProtocolId.optional(),
    protocol_op_template_id: harvestProtocolOperationTemplateId.optional().nullable(),
    source_template_kpi_id: harvestOperationTemplateKpiId.optional().nullable(),
    code: z.string().optional().nullable(),
    name: z.string().optional(),
    formula: z.string().optional(),
    result_unit: z.string().optional().nullable(),
    result_display_unit: z.string().optional().nullable(),
    display_group: z.string().optional().nullable(),
    display_order: z.number().optional(),
    enabled: z.boolean().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=HarvestProtocolKpi.js.map